var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "240"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 액셀 다운로드 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-4"
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "skip",
      "type": "number",
      "placeholder": " ",
      "clearable": "",
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "autofocus": ""
    },
    on: {
      "click:clear": _vm.sync,
      "input": _vm.sync,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs['limit'].focus();
      }
    },
    model: {
      value: _vm.form.skip,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "skip", $$v);
      },
      expression: "form.skip"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    ref: "limit",
    attrs: {
      "label": "limit",
      "type": "number",
      "placeholder": " ",
      "clearable": "",
      "hide-details": "",
      "dense": "",
      "outlined": ""
    },
    on: {
      "click:clear": _vm.sync,
      "input": _vm.sync,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.emit($event);
      }
    },
    model: {
      value: _vm.form.limit,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "limit", $$v);
      },
      expression: "form.limit"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.emit
    }
  }, [_vm._v("다운로드")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }